module.exports = __webpack_public_path__ + "3284dc75b0c2c221985fc1faaa4ea4e0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/squares.png
// module id = 2761
// module chunks = 0